import { useCallback, useMemo } from 'react';

import { useAuth } from 'react-oidc-context';

interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  error: Error | null;
  token: string | null;
}

export const useAuthWrapper = () => {
  const auth = useAuth();

  const state = useMemo<AuthState>(
    () => ({
      isAuthenticated: auth.isAuthenticated,
      isLoading: auth.isLoading,
      error: auth.error || null,
      token: auth.user?.access_token || null,
    }),
    [auth.isAuthenticated, auth.isLoading, auth.error, auth.user]
  );

  return {
    ...state,
    signOut: useCallback(async () => {
      await auth.removeUser();
      await auth.signoutRedirect({
        id_token_hint: auth?.user?.id_token,
      });
      await auth.clearStaleState();
    }, [auth]),
    signIn: useCallback(async () => {
      await auth.signinRedirect();
    }, [auth]),
  };
};
